import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {CompanyProps} from '../types';
import companiesKeys from '../util/companies-keys';

export interface EditCompanyProps {
  name: string;
}

const useEditCompany = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: CompanyProps) => {
    update(companiesKeys.list(), data);
    setData(companiesKeys.details(id), data);
  };

  return useApiMutation<EditCompanyProps>({
    url: `/companies/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar empresa',
    successTitle: 'Editar empresa',
    successMessage: 'Empresa atualizada com sucesso',
    onSuccess,
  });
};

export default useEditCompany;
